'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionDetailController = function () {
    function SelectionDetailController($scope, $state, $stateParams, ApiSelections, ApiTeam, $ionicLoading) {
        _classCallCheck(this, SelectionDetailController);

        this.$ionicLoading = $ionicLoading;
        this.$state = $state;

        this.ApiSelections = ApiSelections;
        this.ApiTeam = ApiTeam;

        this.includedCountries = '';
        this.isGroupAdmin = false;
        this.members = [];
        this.selection = {};
        this.selectionId = $stateParams.selectionId;
    }

    _createClass(SelectionDetailController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            var self = this;
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            this.ApiSelections.getSelection(this.selectionId).then(function (res) {
                _this.selection = res;
                if (_this.selection) {
                    if (_this.selection.selection && _this.selection.selection.investmentType) _this.selection.selection.investmentType = _this.formatText(_this.selection.selection.investmentType);
                    if (_this.selection.selection && _this.selection.selection.country) _this.selection.selection.country = _this.formatText(_this.selection.selection.country);
                    if (_this.selection.selection && _this.selection.selection.investmentProfessionalsTypes) _this.selection.selection.investmentProfessionalsTypes = _this.formatText(_this.selection.selection.investmentProfessionalsTypes);
                }

                return res;
            }).then(function (res) {
                _this.ApiTeam.getTeamMembers({ active: true }).then(function (members) {
                    if (members != undefined) {
                        _this.members = members;
                        _this.includedCountries = _this.retrieveIncludedCountries();
                        // assign member array to each license elemt in the selection array
                        if (members.length > 0 && _this.selection.licenses) {
                            for (var i = _this.selection.licenses.length - 1; i >= 0; i--) {
                                _this.selection.licenses[i].users = members.map(function (m) {
                                    return {
                                        userId: m.id,
                                        firstName: m.firstName,
                                        lastName: m.name,
                                        salutation: m.salutation,
                                        checked: self.checkIfUserIsLicensed(self.selection.licenses[i], m.id)
                                    };
                                });
                            }
                        }
                    }
                    _this.$ionicLoading.hide();
                });
            });

            this.ApiTeam.isGroupAdmin().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.isGroupAdmin = res;
                }
            });
        }
    }, {
        key: 'retrieveIncludedCountries',
        value: function retrieveIncludedCountries() {
            var self = this;
            var uniqueCountries = [];
            self.selection.childrenSelections.forEach(function (childSelection) {
                var country = childSelection.country;
                if (!uniqueCountries.includes(country) && country) {
                    uniqueCountries.push(country);
                }
            });

            return uniqueCountries.join(', ');
        }
    }, {
        key: 'checkIfUserIsLicensed',
        value: function checkIfUserIsLicensed(license, userId) {
            return license.assignedUsers.some(function (elem) {
                return elem.id == userId;
            });
        }
    }, {
        key: 'applyLicenses',
        value: function applyLicenses() {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            var self = this;
            angular.forEach(self.selection.licenses, function (license, key) {
                var selectedMembers = license.users.filter(function (u) {
                    return u.checked === true;
                }).map(function (u) {
                    return u.userId;
                });

                self.ApiSelections.assignLicenses(selectedMembers, license.id).then(function (res) {
                    self.$state.go(self.$state.$current, null, { reload: true });
                });
            });
        }
    }, {
        key: 'formatText',
        value: function formatText(value) {
            return value.replace(/;/g, ', ');
        }
    }]);

    return SelectionDetailController;
}();

exports.default = SelectionDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selectionDetail.controller.js
 **/